import React from 'react'
import Button from './MainButton'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-type='verify-account'>
      <p>Create and Verify Your Account to Get Started</p>
      <Button dataStyle='hero-button' modalName='from-verify-account' />
    </div>
  )
}

export default Component